var XMLNode = require('../xml/XMLNode');
var Alignment = require('./Alignment');

/**
 * Represents a particular Style within the Office Open XML Spreadsheet.
 * Instances of this type will be created by the Styles Class after
 * registering a new Style.
 *
 * @constructor
 */
function Style() {
	XMLNode.call(this, Style.metadata);
}

Style.prototype = Object.create(XMLNode.prototype);
Style.prototype.constructor = Style;

Style.metadata = {
	tag: 'xf',
	attributes: [
		{
			id: 'numberFormat',
			name: 'numFmtId',
			value: '0'
		},
		{
			id: 'font',
			name: 'fontId',
			value: '0'
		},
		{
			id: 'fill',
			name: 'fillId',
			value: '0'
		},
		{
			id: 'border',
			name: 'borderId',
			value: '0'
		}
	]
};

Style.DEFAULT = {
	font: {
		name: 'Arial',
		size: 11,
		family: '2',
		color: '1',
		bold: false
	},
	fill: {
		type: 'none'
	}
};

Style.prototype.getAlignment = function() {
	return this.alignment ? this.alignment : null;
};

Style.prototype.getFontId = function() {
	return this.font.value;
};

Style.prototype.getFillId = function() {
	return this.fill.value;
};

Style.prototype.getBorderId = function() {
	return this.border.value;
};

Style.prototype.getNumberFormatId = function() {
	return this.numberFormat.value;
};

Style.prototype.hasQuotePrefix = function() {
	return 'quotePrefix' in this;
};

/**
 * Applies the alignment to the Style. The alignment must match the
 * predefined options of <code>Alignment</code> as far as it is not
 * null. Other values will be ignored.
 *
 * The value <code>null</code> will delete the current alignment.
 *
 * @param {Object} oAlign - Alignment configuration that gets applied or null
 * @param {string} [oAlign.horizontal] - Horizontal alignment
 * @param {string} [oAlign.vertical] - Vertical alignment
 * @param {number} [oAlign.indent] - Cell indentation
 */
Style.prototype.setAlignment = function(oAlign) {
	var alignment, alignProperty;

	alignProperty = 'alignment';

	// Removes the applyAlignment automatically when sAlign is null
	this._apply(oAlign, 'Alignment');

	if (typeof oAlign === 'undefined' || oAlign === null) {
		this.remove(alignProperty);

		return;
	}

	if (!(alignProperty in this)) {
		alignment = new Alignment();

		this.addChild(alignment);
		Object.defineProperty(this, alignProperty, {value: alignment, writable: false, configurable: true});
	}

	this[alignProperty].setHorizontalAlignment(oAlign.horizontal);
	this[alignProperty].setVerticalAlignment(oAlign.vertical);
	this[alignProperty].setWrapText(oAlign.wrap);
	this[alignProperty].setIndent(oAlign.indent);
};

Style.prototype.setFontId = function(nFontId) {
	this._apply(nFontId, 'Font');

	this.font.value = nFontId;
};

Style.prototype.setFillId = function(nFillId) {
	this._apply(nFillId, 'Fill');

	this.fill.value = nFillId;
};

Style.prototype.setBorderId = function(sBorderId) {
	this.border.value = sBorderId;
};

Style.prototype.setNumberFormatId = function(nNumFmtId) {
	this._apply(nNumFmtId, 'NumberFormat');

	this.numberFormat.value = nNumFmtId;
};

Style.prototype.setQuotePrefix = function(bQuotePrefix) {
	var sAttributeName = 'quotePrefix';

	if (bQuotePrefix && !this.hasQuotePrefix()) {
		this.addAttribute({
			id: sAttributeName,
			name: sAttributeName,
			value: '1'
		});
	} else if (!bQuotePrefix && this.hasQuotePrefix()) {
		this.remove(sAttributeName);
	}
};

Style.prototype._apply = function(nId, sType) {
	var applyProperty = 'apply' + sType;

	this.remove(applyProperty);

	if (nId) {
		this.addAttribute({
			id: applyProperty,
			name: applyProperty,
			value: '1'
		});
	}
};

Style.prototype.equals = function(oStyle) {
	if (!(oStyle instanceof Style)) {
		return false;
	}

	return this.getFontId() === oStyle.getFontId()
		&& this.getFillId() === oStyle.getFillId()
		&& this.getBorderId() === oStyle.getBorderId()
		&& this.getNumberFormatId() === oStyle.getNumberFormatId()
		&& this.hasQuotePrefix() === oStyle.hasQuotePrefix()
		&& ( (!this.alignment && !oStyle.alignment) || (this.alignment && this.alignment.equals(oStyle.alignment)) );
};

module.exports = Style;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/style/Style.js
// module id = 31
// module chunks = 0